<template>
  <div>
    <VHeader :user="user" />
    <truck-scanner :truckId="truckId" />
  </div>
</template>

<script>
import VHeader from "@/components/header.vue";
import TruckScanner from "@/components/user/trucks/TruckScanner.vue";
import User from "@/models/User.js";
export default {
  name: "truck-scanner-window",
  data() {
    return {
      truckId: this.$route.params.truck,
      user: new User(this.$session.get("user")),
    };
  },
  created() {
    if (this.user.company_id == 9) {
      this.$session.destroy();
      this.$router.push("/login").catch(() => {});
    }
  },
  components: {
    VHeader,
    TruckScanner,
  },
};
</script>

<style>
</style>